import axios from "axios";
import router from "@/router";
import { API_URL } from "@/const/api";
import store from "@/store";
import { LOGOUT_USER, UPDATE_TOKENS } from "@/store/action-types";
import { AuthApi } from "@/office/auth/auth-api";

const axiosInstance = axios.create({
  baseURL: API_URL,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
});

axiosInstance.interceptors.response.use(
  (response) => {
    return Promise.resolve(response);
  },
  (error) => {
    if (
      [403, 401].includes(error.response.status) &&
      error.config.url !== "/auth/refresh"
    ) {
      return new AuthApi()
        .refreshToken()
        .then(async (r) => {
          const refreshToken = r.data.refresh_token;
          const accessToken = r.data.access_token;

          await store.dispatch(UPDATE_TOKENS, {
            accessToken: accessToken,
            refreshToken: refreshToken,
          });
          error.config.headers["Authorization"] = `Bearer ${accessToken}`;
          return axios.request(error.config);
        })
        .catch(async () => {
          return Promise.reject(error.response);
        });
    } else if (
      [403, 401].includes(error.response.status) &&
      error.config.url === "/user/login"
    ) {
      return Promise.reject(error.response);
    } else if (error.config.url === "/auth/refresh") {
      store.dispatch(LOGOUT_USER).then(() => {
        router.push({
          path: "/login",
          query: {
            last_refresh_time: new Date().to,
          },
        });
      });
      return Promise.reject(error.response);
    } else {
      return Promise.reject(error.response);
    }
  }
);

export default axiosInstance;
